import { Bar, mixins } from "vue-chartjs"
export default {
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ["options"],
  watch: {
    options: {
      handler(newOption, oldOption) {
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
